var map = {
	"./gallery-wip-plug-pin_00.jpg": 2789,
	"./gallery-wip-plug-pin_01.jpg": 2790,
	"./gallery-wip-plug-pin_02.jpg": 2791,
	"./gallery_00.jpg": 2792,
	"./gallery_01.jpg": 2793,
	"./gallery_02.jpg": 2794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2788;